import { baseApiClient } from "@/utils/api";

let gCient;

const createScript = (params) => {
  return new Promise((resolve) => {
    const el = document.getElementById("google_gsi");
    if (!el) {
      let gplatformScript = document.createElement("script");
      gplatformScript.setAttribute(
        "src",
        "https://accounts.google.com/gsi/client"
      );
      gplatformScript.setAttribute("async", true);
      gplatformScript.setAttribute("defer", "defer");
      gplatformScript.setAttribute("id", "google_gsi");
      gplatformScript.addEventListener("load", () => onGapiLoadPromise(params, resolve));
      document.head.appendChild(gplatformScript);
    }
  });
};

const onGapiLoadPromise = (params, callback) => {
  return new Promise(() => {
    const {clientId, ...rest} = params;
    gCient = window.google.accounts.id.initialize({
      client_id: clientId,
      auto_select: true,
      ...rest,
    });
    callback();
  });
};

const loadingAuth2 = () => {
  if (gCient) {
    return Promise.resolve(gCient);
  }
};

const load = async (params) => {
  const results = await Promise.all([
    loadingAuth2(params),
    createScript(params),
  ]);
  return results[0];
};

const login = async () => {
  return window.google.accounts.id.prompt();
}

const googleLogin = async (token) => {
  const { data } = await baseApiClient.post("/oauth/google", {
    id_token: token.credential,
  });
  return data;
};

export default {
  load,
  login,
  googleLogin,
};
